import truck_trailers from '../assets/images/truck-trailers.jpeg';
import trucks from '../assets/images/trucks.jpeg'

export const slideshowImages: string[] = [
  truck_trailers,
  trucks
];

export const slideshowCaptions: string[] = [
    "Trusted\nLogistics",
    "Quality\nFleet"
]
